import { apiEndpoints } from '@/apiEndpoints';
import type {
  SkippedTrashLink,
  TrashedBenefit,
  TrashedCircuit,
} from '@/types/trash/trashColumnDef';
import axios from 'axios';

export interface TrashParams {
  page?: number;
  pageSize?: number;
}

export const getTrashCount = async () => {
  const result = await axios.get<{
    benefits: number;
    circuits: number;
    total: number;
  }>(apiEndpoints.trash.count);
  return result.data;
};

export const getTrashedBenefits = async ({
  page = 1,
  pageSize = 25,
}: TrashParams) => {
  const result = await axios.get<{ benefits: TrashedBenefit[]; total: number }>(
    apiEndpoints.trash.benefits,
    { params: { page, pageSize } },
  );
  return result.data;
};

export const getTrashedCircuits = async ({
  page = 1,
  pageSize = 25,
}: TrashParams) => {
  const result = await axios.get<{ circuits: TrashedCircuit[]; total: number }>(
    apiEndpoints.trash.circuits,
    { params: { page, pageSize } },
  );
  return result.data;
};

export const restoreBenefits = async (benefitIds: string[]) => {
  const result = await axios.post<{
    count: number;
    skippedLinks: SkippedTrashLink[];
  }>(apiEndpoints.trash.restoreBenefits, { benefitIds });
  return result.data;
};

export const restoreCircuits = async (circuitIds: string[]) => {
  const result = await axios.post<{ count: number }>(
    apiEndpoints.trash.restoreCircuits,
    { circuitIds },
  );
  return result.data;
};
